// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/dist/cjs.js??ref--7-oneOf-1-3!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/postcss-loader/dist/cjs.js??ref--7-oneOf-1-4!../../../../../node_modules/sass-loader/dist/cjs.js??ref--7-oneOf-1-5!./PageArticleList.scss?vue&type=style&index=0&prod&lang=scss&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("68b30f44", content, true, {"sourceMap":false});